<script>
import formInput from "@/mixins/shared/formInput";
import date from "@/mixins/shared/date";

export default {
	mixins: [formInput, date],
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		}
	},
	methods: {
		initialiseEasepick() {
			this.createEasepick({format: 'YYYY-MM-DD'});
		}
	},
	mounted() {
		this.initialiseEasepick();
	}
}
</script>

<template>
	<div class="input-group">
		<template v-if="$slots.addonbefore">
			<span class="input-group-text">
				<slot name="addonbefore"/>
			</span>
		</template>
		<div class="dateinput-wrapper flex-grow-1 p-0">
			<input
				ref="input"
				class="easepick-input"
				:name="name"
				v-bind="$attrs"
				type="date"
				:min="min"
				:max="max"
				:value="modelValue"
				@change="changeDateByKeyboard"
				:id="renderedId"
				:class="{'form-control': true, 'dateinput-wrapper':true, 'border-danger': hasError, 'rounded-start-0' : $slots.addonbefore, 'rounded-end-0' : true}" />
		</div>
		<span class="input-group-text" v-if="$slots.addonafter">
			<slot name="addonafter"/>
		</span>
		<span class="input-group-text" v-if="!$slots.addonafter">
			<i role="button" class="bi bi-calendar" @click="this.$refs.input.click()"></i>
		</span>
	</div>

	<div v-if="$slots.descriptionbottom" class="input-description mt-2">
		<slot name="descriptionbottom"/>
	</div>
	<label v-if="hasError" class="text-danger mt-2 small">
		{{ this.form.errors[this.name] }}
	</label>
</template>